import { Box, Typography } from '@mui/material'

const Clients = () => {
  return (
    <Box 
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        // py: "44px"
      }}
    >
      <Typography variant="h5" component="div" sx={{width: "100%", color: "#bbb", textAlign: "center"}}>Our clients:</Typography>
      <Box
        component="a"
        href="https://pixelantgames.com"
        target="_blank"
        sx={{
          width: "100%",
          height: {xs: "2rem", sm: "3rem"},
          backgroundImage: "url('./assets/pixelAnt.png')",
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          overflow: "hidden",
          filter: "grayscale(100%)",
          cursor: "pointer"
        }}
      >
      </Box>
    </Box>
  )
}

export default Clients;